import 'select2/dist/js/select2.full.min'
require('@claviska/jquery-minicolors');

export default class CustomizeThemeTemplates {

    constructor(options) {

       this._buildSelectThemes();
       this._changeActiveTheme();
       this._setPreviewImage();
       this._initChangeTheme();
       this._initCompanuNameInput();
       this._initColorsInput();
       this._customizedChosenTheme();
       this._uploadClientImage();

    };

    _buildSelectThemes(){
        let $selectTemplates = $( '#select-templates' );
        if(  $($selectTemplates).length ){
            $selectTemplates.select2({
                dropdownCssClass: "dropdown--select-theme",
                templateResult: function (data) {
                    // We only really care if there is an element to pull classes from
                    if (!data.element) {
                        return data.text;
                    }
                    let $element = $(data.element);
                    let $wrapper = $('<span class="mini-preview"></span>');
                    $wrapper.addClass( $($element[0]).val() );
                    $wrapper.text(data.text);
                    return $wrapper;
                }
            });
        }
    }

    _initChangeTheme() {
        var _this = this;
        var $selectTemplates = $( '#select-templates' );
        _this._setPreviewImage();

        $selectTemplates.on('change', function () {
            _this._changeActiveTheme();
        });
    }

    _changeActiveTheme() {
        var _this = this;
        var $selectTemplates = $( '#select-templates' );

        if(  $($selectTemplates).length ){
            let $previewCanvas = $('.booking-templates--customizer .customizer-form .customizer-form--item-preview');

            function resetUploadField(){
                $('#customize-hero-img').val('');
                var file_name_txt = $('.image-file-name'),
                    deff_name_txt = file_name_txt.data('minimal');

                file_name_txt.html( deff_name_txt );
            };

            let $selectedValue = $selectTemplates.find( ':selected' ).val().toLowerCase();
            $previewCanvas.addClass($selectedValue);
            if( this.selectedTheme ){
                $previewCanvas.removeClass( this.selectedTheme );
            }
            this.selectedTheme = $selectedValue;

            _this._setPreviewImage();
            _this._initColorsInput();
            resetUploadField();
        }
    }

    _setPreviewImage(){
        var $selectTemplates = $( '#select-templates' );

        if(  $($selectTemplates).length ){
            let $currentPreview = $selectTemplates.find( ':selected' ).data( 'preview' );
            let $currentDefImg = $selectTemplates.find( ':selected' ).data( 'defimg' );

            let $templateCanvasBack = $('.customizer-form--template-canvas .template-canvas-back');
            let $templateCanvasFront = $('.customizer-form--template-canvas .template-canvas-front');

            $templateCanvasBack.css('background-image' , 'url(' + $currentPreview + ')');
            $templateCanvasFront.css('background-image' , 'url(' + $currentDefImg + ')');
        }
    }

    _initCompanuNameInput(){
        let $companyName = $('#customize-company-name');
        let defVal = $('#customize-company-name').data('value');
        let $templateCanvasTitle = $('.template-canvas--title');

        $companyName.on('change, keyup', function () {
            let enteredText = $companyName.val();
            if( enteredText.length > 0 ){
                $templateCanvasTitle.text( enteredText );
            } else {
                $templateCanvasTitle.text( defVal );
            }
        });
    }

    _initColorsInput(){
        var $selectTemplates = $( '#select-templates' );

        if(  $($selectTemplates).length ){
            function getContrastColor( rgb ) {
                var brightness = Math.round(
                    ((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) /1000
                );
                if (brightness > 125) {
                    return '#000000';
                }
                return '#ffffff';
            };

            let $currentBtnColor = $selectTemplates.find( ':selected' ).data( 'btn-color' );
            let $currentTitleColor = $selectTemplates.find( ':selected' ).data( 'title-color' );

            var $canvasTitle = $('.template-canvas--title');
            var $canvasButton = $('.template-canvas--button');

            $canvasTitle.css('color' , $currentTitleColor);
            $canvasButton.css('background' , $currentBtnColor);

            let $btnColor = $('#buttons-color');
            let $titleColor = $('#title-color');

            //console.log($currentBtnColor, $currentTitleColor);

            $btnColor.minicolors('destroy');
            $titleColor.minicolors('destroy');

            $btnColor.minicolors({
                defaultValue: $currentBtnColor,
                change: function(hex, opacity) {
                    $canvasButton.css('background' , hex);

                    var rgb = $btnColor.minicolors('rgbObject');
                    $canvasButton.css( 'color' , getContrastColor(rgb) );
                },
                hide: function () {

                }
            });

            $titleColor.minicolors({
                defaultValue: $currentTitleColor,
                change: function(hex, opacity) {
                    $canvasTitle.css('color' , hex);
                },
                hide: function () {

                }
            });

            $btnColor.minicolors('value', $currentBtnColor);
            $titleColor.minicolors('value', $currentTitleColor);

            var rgb = $btnColor.minicolors('rgbObject');
            $canvasButton.css( 'color' , getContrastColor(rgb) );
        }
    }

    _customizedChosenTheme(){
        var _this = this;

        var $selectTemplates = $('#select-templates');

        if(  $($selectTemplates).length ){
            var $listLinks = $('.templates-items--list .templates-items--list-item .btn-bar .anchor-link');

            $listLinks.on('click', function () {
                var getSelectedTheme = $(this).data('theme-id');
                var target = $( $(this).attr('href') );
                //console.log(getSelectedTheme);

                if(target.length){
                    var scrollTo = target.offset().top;
                    $('body, html').stop().animate({scrollTop: scrollTo+'px'}, 800);
                }
                $selectTemplates.val(getSelectedTheme);
                $selectTemplates.select2();
                _this._changeActiveTheme();
            })
        }

    }

    _uploadClientImage(){
        var $templateCanvasFront = $('.template-canvas-front');

        if( $templateCanvasFront.length ){

            var inputFile = $('#customize-hero-img'),
            btn = $('.input-upload-block'),
            file_name_txt = $('.image-file-name'),
            deff_name_txt = file_name_txt.data('default');

            file_name_txt.html( deff_name_txt );

            inputFile.on('click', function (e) {
                e.stopPropagation();
            });

            btn.on('click', function(){
                //console.log('click')
                inputFile.click();
            });

            inputFile.on('change', function(e){
                file_name_txt.html( inputFile.val() );

                var i = 0;
                for(i; i < e.originalEvent.target.files.length; i++) {
                    var file = e.originalEvent.target.files[i],
                        reader = new FileReader();

                    reader.onloadend = function(){
                        $templateCanvasFront.css('background-image' , 'url(' + reader.result + ')');
                    }
                    reader.readAsDataURL(file);
                }
            });
        }

    }
}